import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Checkbox } from "../components/ui/checkbox";
import { toast } from "sonner";
import { apiError } from "../lib/errors";

export default function Register() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [params] = useSearchParams();
    const [form, setForm] = useState({ name: "", email: "", password: "", company: "", is_b2b_request: params.get("b2b") === "1" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault(); setLoading(true);
        try {
            await register(form);
            toast.success(form.is_b2b_request ? "Account created — B2B request pending review" : "Account created");
            nav("/account");
        } catch (e) { toast.error(apiError(e, "Registration failed. Passwords need at least 8 characters.")); }
        setLoading(false);
    };

    return (
        <div data-testid="register-page" className="max-w-md mx-auto px-6 py-24">
            <div className="text-[11px] tracking-[0.4em] uppercase text-gold mb-3">Join the Collection</div>
            <h1 className="font-display text-4xl mb-10">Create Account</h1>
            <form onSubmit={submit} className="space-y-4">
                <Input aria-label="Full name" required data-testid="reg-name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Full name" className="bg-charcoal-800 border-[#E2D4C1] rounded-none focus-visible:ring-gold" />
                <Input aria-label="Email" required type="email" data-testid="reg-email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="Email" className="bg-charcoal-800 border-[#E2D4C1] rounded-none focus-visible:ring-gold" />
                <Input required minLength={8} type="password" autoComplete="new-password" aria-label="Password (at least 8 characters)" data-testid="reg-password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="Password (min 8 characters)" className="bg-charcoal-800 border-[#E2D4C1] rounded-none focus-visible:ring-gold" />
                <div className="flex items-center gap-3 pt-2">
                    <Checkbox id="b2b" data-testid="reg-b2b-toggle" checked={form.is_b2b_request} onCheckedChange={(v) => setForm({ ...form, is_b2b_request: !!v })} className="border-gold/40 data-[state=checked]:bg-gold data-[state=checked]:text-white" />
                    <label htmlFor="b2b" className="text-sm text-[#33302C]">Apply for B2B / Wholesale account</label>
                </div>
                {form.is_b2b_request && (
                    <Input aria-label="Company / Shop name" data-testid="reg-company" value={form.company} onChange={e => setForm({ ...form, company: e.target.value })} placeholder="Company / Shop name" className="bg-charcoal-800 border-[#E2D4C1] rounded-none focus-visible:ring-gold" />
                )}
                <Button type="submit" disabled={loading} data-testid="reg-submit" className="w-full bg-gold hover:bg-gold-hover text-white rounded-none uppercase tracking-[0.2em] text-xs font-semibold py-5">{loading ? "Creating…" : "Create Account"}</Button>
            </form>
            <div className="mt-6 text-xs uppercase tracking-widest text-[#6B645C]">Already have an account? <Link to="/login" className="text-gold hover:underline">Sign In</Link></div>
        </div>
    );
}
